<div [@WindowOpenClose]="windowVisible.getValue() ? 'visible' : 'invisible'" #aroContainer class="plot-aro"
  style="min-height: unset;" (click)="windowClick()">
  <dialog-header [label]="'TRACKS.TRACK_TITLE' | translate: {trackTypeStr: trackTypeStr, caspID: caspID}"
    [object]='this' [objectType]='"Track"' [dialogRef]='dialogRef' (mousedown)="windowClick()">
  </dialog-header>
  <!-- <mat-tab-group class="track-aro" dynamicHeight="true" #tabGroup>
    <mat-tab label="{{tab1Label}}"> -->

  <!-- Icon area -->
  <mat-card class="box-bottom-padding-and-border" style="height: 115px;">
    <mat-grid-list cols="30" rowHeight="115">
      <mat-grid-tile colspan="10">
        <!-- <img src="./assets/Images/plane-circle.svg" class="aro-image" />
        <div *ngIf="getTrackType() == 2" class="plane-image" [style.background-color]="identityColor"
          style="-webkit-mask-image: url(../../assets/Images/Objects/missile-weapon.svg);"></div>
        <img *ngIf="getTrackType() != 2" src="./assets/Images/Objects/{{planeSymbol}}.svg" class="plane-image"
          style="fill: tomato;"> -->
        <div>
          <img src="./assets/Images/plane-circle.svg" class="aro-image" />
          <div class="plane-image" [style.background-color]="identityColor"
            style="-webkit-mask-image: url(../../assets/Images/Objects/fighter-plane.svg);"></div>
        </div>
      </mat-grid-tile>
      <mat-grid-tile colspan="20" style="right: auto">

        <!-- Hostility -->
        <div fxFlex="100%" fxLayout="column" fxLayoutAlign="center center">
          <!-- <mat-select style="position: unset; width: 90%;" class="identity" #identitySelect [value]="identityValue"
            (selectionChange)="onHostilitySelected($event)">
            <mat-option *ngFor="let ident of identities" [style.color]="colorOfIdentity(ident.id)" [value]="ident.id"
              [disabled]="ident.id == 0">{{ident.title}}</mat-option>
          </mat-select> -->
          <div style="margin: 5px"></div>
          <div fxFlex="100%" fxLayout="column" fxLayoutAlign="center center">
            <div>{{time}}</div>
            <div class="aro-label" style="margin-top: 2px;">{{'ARO.LAST_UPDATED' | translate}}</div>
            <div style="margin-top: 10px;">{{age}}</div>
            <div class="aro-label" style="margin-top: 2px;">Age</div>
          </div>
        </div>

        <!-- data on ABT Track set to false because not used -->
        <!-- <div fxFlex="100%" fxLayout="column" fxLayoutAlign="center center" *ngIf="getTrackType() == 1"> -->
        <div fxFlex="100%" fxLayout="column" fxLayoutAlign="center center" *ngIf="false">
          <!-- modes 1-3 -->
          <!-- <mat-card style="width: 90%; border: none; border-bottom: none;"> -->
          <div *ngIf="false" fxLayout="row" fxLayoutGap="0px" fxLayoutAlign="space-evenly" style="width: 90%;">
            <div fxFlex="33%" fxLayout="column" fxLayoutAlign="center center">
              <div>{{mode1}}</div>
              <div class="aro-label">{{'ARO.MODE_1' | translate}}</div>
            </div>
            <div fxFlex="34%" fxLayout="column" fxLayoutAlign="center center">
              <div>{{mode2}}</div>
              <div class="aro-label">{{'ARO.MODE_2' | translate}}</div>
            </div>
            <div fxFlex="33%" fxLayout="column" fxLayoutAlign="center center">
              <div>{{mode3}}</div>
              <div class="aro-label">{{'ARO.MODE_3' | translate}}</div>
            </div>
          </div>
          <!-- </mat-card> -->
        </div>

        <!-- data on TBM Track set to false because not used -->
        <div *ngIf="false">
          <div fxFlex="100%" fxLayout="column" fxLayoutAlign="center center" *ngIf="getTrackType() == 2">
            <div style="margin-top: 15px;"></div>
            <div>{{boostPhase}}</div>
            <div class="aro-label">{{'ARO.BOOST_PHASE' | translate}}</div>
            <div style="margin-top: 10px;"></div>
            <div>{{maneuver}}</div>
            <div class="aro-label">{{'ARO.MANEUVERING' | translate}}</div>
          </div>
        </div>
      </mat-grid-tile>

      <!-- <mat-grid-tile colspan="4">
        <div style="position: absolute; right: 0px; top: 4px;">
          <button mat-mini-fab class="mat-flag-button" [style.background-image]="nationality"></button>
        </div>
      </mat-grid-tile> -->
    </mat-grid-list>
  </mat-card>

  <!-- Classification opr -->
  <!-- <mat-card class="box-bottom-border" *ngIf="trackType != 2">
    <div fxLayout="row" fxLayoutGap="0px" fxLayoutAlign="space-evenly">
      <div fxFlex="100%" class="box-top-bottom-padding" fxLayout="row" fxLayoutAlign="center center">
        <mat-form-field style="width: 150px; margin: auto;">
          <mat-label>Classifications</mat-label>
          <mat-select [formControl]="classifControl" (selectionChange)="onClsSelected($event, true)" placeHolder="-1"
            #clsformSelect>
            <mat-option [value]="">
              None
            </mat-option>
            <mat-option *ngFor="let cls of classifs" [value]="cls">
              {{cls}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field style="width: 150px; margin: auto;">
          <mat-label>Platforms</mat-label>
          <mat-select [formControl]="platformControl" (selectionChange)="onPltSelected($event)" placeHolder="-1"
            #platformSelect>
            <mat-option style="width: 150px;">
              <ngx-mat-select-search [formControl]="filteredPlatsCtrl" [placeholderLabel]="'ACTIONS.SEARCH'| translate"
                noEntriesFoundLabel="No Platforms Found"></ngx-mat-select-search>
            </mat-option>
            <mat-option [value]="">
              None
            </mat-option>
            <mat-option *ngFor="let plt of filteredPlats | async" [value]="plt">
              {{plt}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </mat-card> -->

  <!-- Classification sys -->
  <mat-card class="box-bottom-padding-and-border">
    <div fxLayout="column" fxLayoutGap="5px" fxLayoutAlign="center center">
      <div>{{cls}}</div>
      <div class="aro-label">Classification</div>
    </div>
  </mat-card>

  <!-- Location -->
  <mat-card class="box-bottom-padding-and-border">
    <div fxLayout="column" fxLayoutGap="5px" fxLayoutAlign="center center">
      <mat-icon class="location-icon" (click)="setLocationClick()">place</mat-icon>
      <div>{{location}}</div>
      <div class="aro-label" style="user-select: none; cursor: pointer;" (click)="locationClick()">({{locUnits}})</div>
    </div>
  </mat-card>

  <!-- Dynamic data -->
  <mat-card class="box-bottom-padding-and-border">
    <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="15px">
      <div fxLayout="column" fxLayoutAlign="center center">
        <div class="track-aro-alt">
          <img class="track-aro-alt-circle" src="./assets/Images/track-aro-alt.svg" />
          <span class="track-aro-alt-value">{{altitude}}</span>
          <span class="track-aro-alt-units">{{altitudeUnits}}</span>
          <svg class="track-aro-alt-gauge" viewBox="0 0 179.474 178.675" width="179.474px" height="178.675px">
            <linearGradient id="gradAlt" x1="1" x2="0">
              <stop offset="0%" style="stop-color: aqua" [style.stop-opacity]="altMinOpacity" />
              <stop [attr.offset]="altPercentGrad1" style="stop-color: aqua; stop-opacity: 0.7" />
              <stop [attr.offset]="altPercentGrad2" style="stop-color: aqua; stop-opacity: 1" />
              <stop [attr.offset]="altPercentActual" style="stop-color: aqua; stop-opacity: 1" />
              <stop [attr.offset]="altPercentCutoff" style="stop-color: aqua; stop-opacity: 0" />
              <stop offset="100%" style="stop-color: aqua" [style.stop-opacity]="altMaxOpacity" />
            </linearGradient>
            <g>
              <circle #altCircle r="77" cx="89.75" cy="89.34" stroke="url(#gradAlt)" stroke-width="9" fill="none" />
            </g>
          </svg>
        </div>
        <div class="aro-label">{{'ARO.ALTITUDE' | translate}}</div>
      </div>
      <div fxLayout="column" fxLayoutAlign="center center">
        <div class="track-aro-spd">
          <img class="track-aro-spd-circle" src="./assets/Images/track-aro-spd.svg" />
          <span class="track-aro-spd-value">{{speedShow}}</span>
          <span class="track-aro-spd-units">{{speedUnits}}</span>
          <svg class="track-aro-spd-gauge" viewBox="0 0 179.474 178.675" width="179.474px" height="178.675px">
            <linearGradient id="gradSpdLeft">
              <stop offset="0%" style="stop-color: aqua; stop-opacity: 1" />
              <stop offset="80%" style="stop-color: aqua; stop-opacity: 0.4" />
              <stop offset="100%" style="stop-color: aqua; stop-opacity: 0.2" />
            </linearGradient>
            <clipPath id="clipPathSpdLeft">
              <rect x="0" y="88" width="179" height="89" />
            </clipPath>
            <clipPath id="clipPathSpdRight">
              <rect x="0" y="0" width="179" height="90" />
            </clipPath>
            <g>
              <circle #speedCircle r="77" cx="89.75" cy="89.34" stroke="url(#gradSpdLeft)"
                clip-path="url(#clipPathSpdLeft)" [style.strokeDasharray]="speedCircleDasharray"
                [style.strokeDashoffset]="speedCircleDashoffset" stroke-width="9" fill="none" />
              <circle #speedCircle r="77" cx="89.75" cy="89.34" stroke="aqua" clip-path="url(#clipPathSpdRight)"
                [style.strokeDasharray]="speedCircleDasharray" [style.strokeDashoffset]="speedCircleDashoffset"
                stroke-width="9" fill="none" />
            </g>
          </svg>
        </div>
        <div class="aro-label">{{'ARO.SPEED' | translate}}</div>
      </div>
      <div fxLayout="column" fxLayoutAlign="center center">
        <div class="track-aro-hdg">
          <img class="track-aro-hdg-circle" src="./assets/Images/track-aro-hdg.svg" />
          <span class="track-aro-hdg-value">{{heading}}&deg;</span>
          <svg [style.transform]="headingRotate" class="track-aro-hdg-gauge" viewBox="0 0 179.474 178.675"
            width="179.474px" height="178.675px">
            <linearGradient id="gradHdg" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" style="stop-color: aqua; stop-opacity: 0" />
              <stop offset="50%" style="stop-color: aqua; stop-opacity: 0.2" />
              <stop offset="80%" style="stop-color: aqua; stop-opacity: 0.4" />
              <stop offset="90%" style="stop-color: aqua; stop-opacity: 1" />
              <stop offset="100%" style="stop-color: aqua; stop-opacity: 1" />
            </linearGradient>
            <g>
              <path d=" M 72 170.58 C 76.819 173.471 100.613 174.049 106.074 170.675 L 89.09 98.101 Z "
                fill="url(#gradHdg)" />
              <line x1="89.241" y1="96.951" x2="89.241" y2="7.903" />
            </g>
          </svg>
        </div>
        <div class="aro-label">{{'ARO.HEADING' | translate}}</div>
      </div>
    </div>
  </mat-card>

  <!-- Climb Rate and Track Status -->
  <mat-card class="box-bottom-border">
    <div fxLayout="row" fxLayoutGap="0px" fxLayoutAlign="space-evenly">
      <div fxFlex="50%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
        <div>{{velocityZ}}</div>
        <div fxLayout="row" fxLayoutGap="5px">
          <div class="aro-label">{{'ARO.CLIMB_RATE' | translate}}</div>
          <div class="aro-label" *ngIf="velZValid">({{velocityZUnits}})</div>
        </div>
      </div>
      <div fxFlex="50%" fxLayout="column" fxLayoutAlign="center center">
        <div>{{trackStatus}} </div>
        <div class="aro-label">{{'ARO.TRACK_STATUS' | translate}}</div>
      </div>
    </div>
  </mat-card>

  <!-- External Track Data -->
  <mat-card class="box-bottom-border" *ngIf="isExternal">
    <div fxLayout="row" fxLayoutGap="0px" fxLayoutAlign="space-evenly">
      <div fxFlex="50%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
        <div>{{externalTN}}</div>
        <div class="aro-label" *ngIf="">{{'ARO.EXTERNAL_ID' | translate}}</div>
      </div>
      <div fxFlex="50%" fxLayout="column" fxLayoutAlign="center center">
        <div>{{remoteHostility}} </div>
        <div class="aro-label">{{'ARO.EXTERNAL_HOSTILITY' | translate}}</div>
      </div>
    </div>
  </mat-card>

  <!-- </mat-tab> -->
  <!-- <mat-tab *ngIf="trackType == 1" label="{{tab2Label}}">
      <ng-template #tab2Container></ng-template>
    </mat-tab> -->
  <!-- <mat-tab *ngIf="tab3Label != undefined" label="{{tab3Label}}">
      <ng-template #tab3Container></ng-template>
    </mat-tab>
    <mat-tab *ngIf="tab4Label != undefined" label="{{tab4Label}}">
      <ng-template #tab4Container></ng-template>
    </mat-tab> -->
  <!-- </mat-tab-group> -->
</div>